<div class="container">
    <div class="container-item">
        <div class="item-row">
            <div class="entity-area text-ellipsis">
                <span class="entity" *ngFor="let item of task.entities">
                    <label title="{{item.shortName}}">{{item.shortName}}</label>
                </span>
            </div>
            <div class="status-area" (mouseleave)="mouseleave()">
                <div class="task-status text-12"
                    [ngClass]="task.status==='Todo'?'task-todo':(task.status==='Done'?'task-done':'task-inprogress')"
                    (mouseover)="mouseover($event)" *ngIf="showTaskStatus">
                    {{task.status}}</div>
                <div class="create-by-me" *ngIf="!showTaskStatus">
                    <div class="task-status text-12" (mouseover)="mouseover()"
                        [ngClass]="task.status==='Done'?'task-done':(task.doneTasksNum===0?'task-todo':'task-inprogress')">
                        {{task.doneTasksNum}}/{{task.allTasksNum}}
                    </div>
                    <div class="popover" *ngIf="showPopover" (click)="popoverClick($event)">
                        <div class="tab">
                            <tabs [options]="tabsOptions" [underlineStyle]="true">
                            </tabs>
                        </div>
                        <div class="content">
                            <div *ngIf="tabActive===0" class="assignee">
                                <div *ngFor="let item of task.ongoingTasks">
                                    <div class="name" title="{{item.assignee.name}}">
                                        <span>{{item.assignee.name}}</span>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="tabActive===1" class="assignee">
                                <div *ngFor="let item of task.doneTasks">
                                    <div class="name" title="{{item.assignee.name}}">
                                        <span>{{item.assignee.name}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="item-row">
            <div class="subject-area  text-ellipsis" [ngClass]="task.dueDate ? 'width-has-date' : 'width-no-date'">
                <span class="subject" title="{{task.subject}}">{{task.subject}}</span>
            </div>
            <div class="date-area" *ngIf="task.dueDate">
                <smart-icon name="timer" *ngIf="!task.taskOverdue"></smart-icon>
                <smart-icon name="timer-red" *ngIf="task.taskOverdue"></smart-icon>
                <div class="date text-12" *ngIf="task.showTime" [ngClass]="{'overdue':task.taskOverdue}">
                    {{task.dueDate | date: 'dd MMM yyyy, HH:mm'}}</div>
                <div class="date text-12" *ngIf="!task.showTime" [ngClass]="{'overdue':task.taskOverdue}">
                    {{task.dueDate | date: 'dd MMM yyyy'}}</div>
            </div>
        </div>
    </div>
</div>